import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=4ceb4d32&scoped=true&"
import script from "./AccountDelete.vue?vue&type=script&lang=js&"
export * from "./AccountDelete.vue?vue&type=script&lang=js&"
import style0 from "./AccountDelete.vue?vue&type=style&index=0&id=4ceb4d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceb4d32",
  null
  
)

export default component.exports